import PredictiveSearch from '@/lib/predictive-search';

const selectors = {
  trigger: '.quick-search__trigger',
  searchOverlay: '.search__overlay',
  searchInput: '.search__input',
  inputClear: '.search__input-clear',
  inputClose: '.search__input-close',
  results: '.search__results',
  settings: '[data-settings]',
};

const classNames = {
  active: 'is-active',
  activeQuery: 'has-active-query',
  activeSuggestions: 'has-suggestions',
};

const quickSearch = opts => {
  const container = opts.container;

  const settings = container.querySelector(selectors.settings);
  const trigger = container.querySelector(selectors.trigger);
  const overlay = container.querySelector(selectors.searchOverlay);
  const searchInput = container.querySelector(selectors.searchInput);
  const searchInputClear = container.querySelector(selectors.inputClear);
  const searchInputClose = container.querySelector(selectors.inputClose);
  const resultsContainer = container.querySelector(selectors.results);

  const events = [];

  const options = JSON.parse(settings.innerHTML);

  const search = PredictiveSearch({ opts: options });

  search.on('success', ({ markup }) => {
    container.classList.add(classNames.activeSuggestions);

    resultsContainer.innerHTML = markup;
  });

  const _bindEvents = () => {
    _addEvent(trigger, 'click', _showSearchBar);
    _addEvent(overlay, 'click', _hideSearchBar);
    _addEvent(document, 'keydown', _handleEsq);
    _addEvent(searchInput, 'input', _searchInputHandler);
    _addEvent(searchInputClose, 'click', _hideSearchBar);
    _addEvent(searchInputClear, 'click', _clearSearchInput);
  };

  const _addEvent = (element, action, func) => {
    element.addEventListener(action, func, true);

    events.push({
      element,
      action,
      func,
    });
  };

  const _showSearchBar = e => {
    e.preventDefault();
    trigger.setAttribute('aria-expanded', true);
    searchInputClose.setAttribute('aria-expanded', true);

    container.classList.add(classNames.active);
    searchInput.focus();
  };

  const _hideSearchBar = e => {
    e.preventDefault();
    trigger.setAttribute('aria-expanded', false);
    searchInputClose.setAttribute('aria-expanded', false);

    container.classList.remove(classNames.active);
  };

  const _handleEsq = e => {
    if (container.classList.contains(classNames.active) && e.keyCode === 27) {
      _hideSearchBar(e);
    }
  };

  const _clearSearchInput = e => {
    e.preventDefault();

    searchInput.value = '';
    _searchInputHandler(e);
    searchInput.focus();
  };

  const _searchInputHandler = event => {
    const query = event.target.value;

    if (!query) {
      container.classList.remove(classNames.activeQuery);
      container.classList.remove(classNames.activeSuggestions);
      return;
    }

    container.classList.add(classNames.activeQuery);

    if (options.show_products || options.show_pages || options.show_articles) {
      search.query(query);
    }
  };

  const unload = () => {
    events.forEach(event => {
      event.element.removeEventListener(event.action, event.function);
    });
  };

  _bindEvents();

  return { unload };
};

export default quickSearch;
